import { useField } from './hooks';
export var Field = function (_a) {
    var field = _a.field, render = _a.render;
    var props = useField(field);
    return render(props);
};
Field.displayName = 'Field';
//# sourceMappingURL=Field.js.map